import React, { Component } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

const JobList = styled.iframe`
  width: 100%;
  border: none;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  padding: ${rem(1)} ${rem(10)} 0;
  margin-top: ${rem(15)};
  border-radius: ${props => props.theme.borderRadius.S};
`

function buildPositionScript() {
  const script = document.createElement('script')
  script.src = 'https://dqalqqxcpkg5p.cloudfront.net/scripts/widgets/job-listings-widget.host.1.0.4.js'
  script.async = true
  return script
}

interface Props {}

class OpenPositions extends Component<React.PropsWithChildren<Props>> {
  elements = {
    PositionScript: buildPositionScript(),
  }

  componentDidMount() {
    document.body.appendChild(this.elements.PositionScript)
  }

  componentWillUnmount() {
    document.body.removeChild(this.elements.PositionScript)
  }

  render() {
    return (
      <JobList
        title="open-jobs"
        className="lh-job-listings-widget"
        src="https://www.livehire.com/widgets/job-listings/luxuryescapes"
        scrolling="no"
      >
      </JobList>
    )
  }
}

export default OpenPositions
